import React, { useState, useEffect } from 'react';

const DisplaySmallCards = ({ card }) => {
  const [cardSymbol, setCardSymbol] = useState('');
  const [cardValue, setCardValue] = useState('');
  const [isRed, setIsRed] = useState(false);

  useEffect(() => {
    if (card) {
      const value = card.slice(0, -1);
      const symbol = card.slice(-1);

      setCardSymbol(symbol);
      setCardValue(value);
      setIsRed(symbol === '♦' || symbol === '♥');
    }
  }, [card]);

  return (
    <div id="card" className={`card ${isRed ? 'red-card' : ''}`} style={{ width: '60px', height: '75px' }}>
      <div className="d-flex justify-content-start pl-5">
        <h2 className="fs-mobile card-num-top h-25">{cardValue}</h2>
        <h2 className="fs-mobile card-num-top h-25">{cardSymbol}</h2>
      </div>
      <div className="fsc-mobile d-flex justify-content-center align-items-center h-75">{cardValue}{cardSymbol}</div>
      <div className="d-flex justify-content-start pr-5" style={{ transform: 'scale(-1)' }}>
        <h2 className="fs-mobile card-num-top h-25 float-end">{cardValue}</h2>
        <h2 className="fs-mobile card-num-top h-25">{cardSymbol}</h2>
      </div>
    </div>
  );
};

export default DisplaySmallCards;